import { render, staticRenderFns } from "./SaldosTodosFiltersForm.vue?vue&type=template&id=2f6f6df6"
import script from "./SaldosTodosFiltersForm.vue?vue&type=script&lang=ts"
export * from "./SaldosTodosFiltersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports